import React, {useState, useRef} from 'react';
import PropTypes from 'prop-types';
import Translate from './Translate';
import {prepaidVoucherExist} from '../api/utils';
import LoadableSubmit from './loadableComponents/LoadableSubmit';
import FocusableTrigger from './FocusableTrigger';
import errorstype from '../types/errors';
import ControlledTextInput from './formComponents/ControlledTextInput';
import TimeoutModal from "./TimeoutModal";

const VoucherEntry = ({
  errors,
  paymentSelected,
  prepaidVoucher,
  updateVoucherCode,
  updateVoucherFromBackend,
  voucher,
  voucherSupported,
  timeoutModal,
}) => {
  const [open, setOpen] = useState(false);
  const redeemVoucher = () => updateVoucherFromBackend();

  const [voucherCodeValue, setVoucherCodeValue] = useState('');
  const [prevValue, setPrevValue] = useState('');
  const prepaidVoucherRedeemed = prepaidVoucherExist(prepaidVoucher);
  const voucherInputRef = useRef(null);

  const onBlur = (name, value) => {
    return updateVoucherCode(value);
  };

  const onChange = (e) => {
    const value = e.target.value;

    return setVoucherCodeValue(value);
  };

  if (voucher.code !== prevValue) {
    setVoucherCodeValue(voucher.code);
    setPrevValue(voucher.code);
  }

  const handleOnVoucherApplied = (voucherCode, scrollToRef = true) => {
    setOpen(true)
    setVoucherCodeValue(voucherCode)
    if (scrollToRef) {
      window.scrollTo({
        behavior: 'smooth',
        top:
          voucherInputRef.current?.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          120,
      })
    }
  }

  if (
    voucherCodeValue === '' &&
    localStorage.getItem('inactivity-voucher-code'))
  {
    handleOnVoucherApplied(localStorage.getItem('inactivity-voucher-code'), false)
    localStorage.removeItem('inactivity-voucher-code');
  }

  window.addEventListener('storage-inactivity-voucher-code', () => {
    handleOnVoucherApplied(localStorage.getItem('inactivity-voucher-code'), false)
  })

  return (
    <>
      {timeoutModal && (
        <TimeoutModal key="timeoutModal" onVoucherApplied={handleOnVoucherApplied} data={timeoutModal} mobile={false} />
      )}
      <div ref={voucherInputRef} className="voucher-entry">
        <div className="voucher-entry__trigger-container">
          <FocusableTrigger
            className="voucher-entry__trigger"
            onClick={() => setOpen(!open)}
          >
            {open ?
              (<Translate content="Close voucher code" />)
              :
              (<Translate content="Apply voucher code" />)
            }
          </FocusableTrigger>
        </div>
        {open && (
          <>
            <label className="form-label" htmlFor="voucher-input">
              <Translate content="Voucher code" />
            </label>
            <div>
              <div className="group">
                <div className="form-field form-field--voucher voucher-entry__form">
                  <ControlledTextInput
                    className="text-input"
                    disabled={!voucherSupported}
                    errorText={errors.voucher}
                    id="voucher"
                    name="voucher-input"
                    onBlur={onBlur}
                    onChange={onChange}
                    placeholder="XXX-XXX-XX"
                    type="text"
                    value={voucherCodeValue}
                  />
                </div>
                <LoadableSubmit
                  className="voucher-entry__confirm"
                  content="Redeem"
                  disabled={!voucherSupported}
                  loadingWrapClass="loading-wrap-voucher"
                  onClick={redeemVoucher}
                />
              </div>
              {prepaidVoucherRedeemed && (
                <div className="message message--info voucher-entry__message">
                  <Translate
                    args={{'!amount': `${prepaidVoucher.amount} ${prepaidVoucher.currencyCode}`}}
                    content="!amount from the voucher has been adjusted against the payment of this booking."
                  />
                </div>
              )}

              {!prepaidVoucherRedeemed && paymentSelected && voucherSupported && (
                <div className="message message--info voucher-entry__message">
                  <Translate content="Please note that the discount is deducted from the rent price." />
                </div>
              )}
              {!voucherSupported && (
                <div className="message message--info voucher-entry__message">
                  <Translate content="Discount codes and gift cards cannot be used with this payment method." />
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

VoucherEntry.PropTypes = {
  errors:errorstype,
  paymentSelected: PropTypes.bool.isRequired,
  prepaidVoucher: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    currencyCode: PropTypes.string.isRequired,
  }),
  updateVoucherCode: PropTypes.func.isRequired,
  updateVoucherFromBackend: PropTypes.func.isRequired,
  voucher:PropTypes.shape({
    code:PropTypes.string,
  }).isRequired,
  voucherSupported:PropTypes.bool.isRequired,
  timeoutModal:PropTypes.object.isRequired,
};

export default VoucherEntry;
